<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
    :transition="false"
  >
    <v-card @click="userAction()">
      <v-card-title class="logout-header">
        {{ $t('token.title') }}
      </v-card-title>
      <v-divider />
      <v-card-text>
        <p class="logout-text mb-0">
          {{ $t('token.logout') }} {{ timeToLogout }}
        </p>
        <p class="logout-text mb-0">
          {{ $t('token.info') }}
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    name: 'BeforeLogoutModal',
    data () {
        return {
            dialog: false
        };
    },
    computed: {
        logoutModal () {
            return this.$store.getters['token/logoutModal'];
        },
        timeToLogout () {
            return this.$store.getters['token/timeToLogout'];
        }
    },
    watch: {
        logoutModal (val) {
            this.dialog = val;
        }
    },
    methods: {
        userAction () {
            this.$store.commit('token/activeUserAction');
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables';
.logout-header {
  color: $sz_grafit;
  font-size: 16px;
}
.logout-text {
  color: $sz_dark_grey;
  font-size: 16px;
}
</style>
